import React from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

/**
 * Bottom sheet chuẩn cho “Lọc nâng cao” trên mobile.
 * - Portal ra document.body để phủ header + bottom nav (shell có isolation + z-index).
 * - Overlay làm mờ toàn app; sheet cố định 80% chiều cao viewport/app.
 */
export default function MobileAdvancedFilterSheet({
  open,
  onClose,
  title = "Bộ lọc nâng cao",
  children,
  footer = null,
}) {
  if (typeof document === "undefined") return null;

  return createPortal(
    <AnimatePresence>
      {open ? (
        <div
          className="fixed inset-0 z-[200] flex items-end"
          data-mobile-advanced-filter-sheet=""
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/45 backdrop-blur-sm"
            aria-hidden
          />
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-label={title}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 380, damping: 36 }}
            className="relative flex h-[80dvh] max-h-[80%] w-full flex-col rounded-t-[2rem] bg-white px-6 pb-6 pt-5 shadow-2xl"
            style={{ height: "80dvh", maxHeight: "80%" }}
          >
            <div className="mb-4 flex shrink-0 items-center justify-between gap-3">
              <h3 className="text-lg font-bold uppercase tracking-tight text-gray-800">
                {title}
              </h3>
              <button
                type="button"
                onClick={onClose}
                className="rounded-full bg-gray-100 p-2 text-gray-500"
                aria-label="Đóng"
              >
                <X size={20} />
              </button>
            </div>

            <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
              {children}
            </div>

            {footer ? (
              <div className="mt-4 flex shrink-0 gap-3 border-t border-gray-100 pt-4">
                {footer}
              </div>
            ) : null}
          </motion.div>
        </div>
      ) : null}
    </AnimatePresence>,
    document.body
  );
}
